import * as Sentry from '@sentry/react';
import React from 'react';
import ErrorRoute from '~/routes/error';
const ErrorHandler = ({ children }) => {
    return (React.createElement(Sentry.ErrorBoundary, { fallback: React.createElement(ErrorRoute, null) }, children));
};
export default ErrorHandler;
